import { createFeatureFlagContext } from '@reckon-web/feature-flags';

import { BookSetupWizardDefaultFeatureFlag } from './BookSetupWizardDefaultFeatureFlag';

export const BookSetupWizardDefaultFeatureFlagContext = createFeatureFlagContext(
  BookSetupWizardDefaultFeatureFlag
);
